export default __webpack_public_path__ + "static/media/thankyou.7f1260ce.jpg";